import styled from "styled-components";

export default styled.div`
    flex-direction: column;
    flex-grow: 1;
    display: flex;
`;
